import actionCreators from 'actionCreators/index';
import {BasicFileUpload} from 'components/FileUpload';
import AnalyticsGateway from 'lib/AnalyticsGateway';
import {connect} from 'react-redux';
import {Button, Progress} from 'semantic-ui-react';

const mapStateToProps = (state, ownProps) => {
  return {
    accept: 'image/png, image/jpeg',
    uploadProgress: state.uploadProgress,
    propertyId: state.propertyDetail.propertyId,
    className: ownProps.className || 'add-cover-image',
    basicView: <Button className="add-image-btn" icon="plus" content="Add Image"/>,
    uploadingView: <div className={`uploading ${ownProps.className || 'add-cover-image'}`}>
      <Progress percent={state.uploadProgress} indicating />
    </div>,
    ...ownProps,
  };
};

const mapDispatchToProps = (dispatch, ownProps) => (
  {
    onUpload: ({files, event, propertyId, type}) => {
      dispatch(actionCreators.addCoverImage({
        type,
        file: files[0],
        callback: ownProps.onUpload,
      }));

      const eventType = event.type === 'drop' ? 'Drop' : 'Browse';
      AnalyticsGateway.sendEvent({
        eventName: 'Upload Cover Image',
        properties: [
          {label: 'Page', value: 'Customise Report'},
          {label: 'Property ID', value: propertyId},
          {label: 'Upload Method', value: eventType},
          {label: 'Image Name', value: files[0].name},
          {label: 'Image Type', value: files[0].type},
          {label: 'Layout', value: type},
        ]
      });
    }
  }
);

const mergeProps = (stateProps, dispatchProps) => ({
  ...stateProps,
  ...dispatchProps,
  onUpload: (files, event) => {
    const {type, propertyId} = stateProps;
    dispatchProps.onUpload({files, event, propertyId, type});
  },
});

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(BasicFileUpload);